// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
import { createSelector, OutputSelector } from "reselect"

import { TYPES } from "../../consts/windowConsts"
import type { WindowResizeAction } from "./actions"

type WindowState = {
  type: "desktop" | "tablet" | "mobile"
}

type State = {
  window: WindowState
}

export default function WindowReducer(
  state: WindowState | null | undefined = { type: TYPES.DESKTOP },
  action: WindowResizeAction,
) {
  switch (action.type) {
    case "WINDOW_RESIZE":
      return { ...state, type: action.windowType }

    default:
      return state
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const windowSelector = (state: any) => state.window

export const windowTypeSelector = createSelector(windowSelector, (state) => state.type)

/**
 * @deprecated use {@link #isOrbitTabletSelector()} instead.
 */
export const isMobileSelector = createSelector(windowTypeSelector, (type) => type === TYPES.MOBILE)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isSmallerThanDesktopSelector: (state: { window: any }) => boolean = createSelector(
  windowTypeSelector,
  (type) => type === TYPES.MOBILE || type === TYPES.TABLET,
)

// @ts-expect-error: Flow to TS migration.
export const isOrbitTabletSelector: OutputSelector<State, undefined, boolean> = createSelector(
  isMobileSelector,
  (isMobile) => isMobile,
)
